// src/data/products/tmtBars.js
import tmtBarsImg from '../../assets/images/tmt-bars.jpg';

export const tmtBarsData = {
  slug: 'tmt-bars',
  name: 'TMT Bars',
  image: tmtBarsImg,
  description: 'High-strength Thermo-Mechanically Treated steel bars for reinforced concrete structures with superior bendability and weldability.',
  subcategories: [
    {
      slug: 'raigarh-tmt-bar',
      name: 'Raigarh TMT Bar',
      description: 'Superior quality TMT bars from Raigarh steel plants for construction excellence.',
      image: tmtBarsImg,
      products: [
        {
          slug: 'shubh-gold-tmt',
          name: 'SHUBH GOLD TMT',
          image: tmtBarsImg,
          shortDesc: 'Premium SHUBH GOLD TMT bars for superior construction.',
          description: 'SHUBH GOLD TMT bars are engineered for superior performance in construction projects, offering excellent strength and durability.',
          dimensions: [
            { size: '8mm', weight: '0.395 kg/m', price: 'Price on Request' },
            { size: '10mm', weight: '0.617 kg/m', price: 'Price on Request' },
            { size: '12mm', weight: '0.888 kg/m', price: 'Price on Request' },
            { size: '16mm', weight: '1.580 kg/m', price: 'Price on Request' },
            { size: '20mm', weight: '2.469 kg/m', price: 'Price on Request' },
            { size: '25mm', weight: '3.858 kg/m', price: 'Price on Request' },
          ],
          specifications: [
            { property: 'Grade', value: 'Fe 500' },
            { property: 'Yield Strength', value: '≥ 500 MPa' },
            { property: 'Ultimate Tensile Strength', value: '≥ 545 MPa' },
            { property: 'Elongation', value: '≥ 14.5%' },
            { property: 'Bend Test', value: 'No cracking' }
          ],
          terms: [
            'Prices are subject to change based on market conditions without prior notice.',
            'GST and other applicable taxes are extra.',
            'Loading charges will be borne by the buyer.',
            'Advance payment is required before dispatch of goods.',
            'All sales are subject to our standard terms and conditions.'
          ]
        },
        {
          slug: 'yug-tmt',
          name: 'YUG TMT',
          image: tmtBarsImg,
          shortDesc: 'High-performance YUG TMT bars for structural applications.',
          description: 'YUG TMT bars are manufactured with advanced technology to provide excellent strength and durability for all construction needs.',
          dimensions: [
            { size: '8mm', weight: '0.395 kg/m', price: 'Price on Request' },
            { size: '10mm', weight: '0.617 kg/m', price: 'Price on Request' },
            { size: '12mm', weight: '0.888 kg/m', price: 'Price on Request' },
            { size: '16mm', weight: '1.580 kg/m', price: 'Price on Request' },
            { size: '20mm', weight: '2.469 kg/m', price: 'Price on Request' },
            { size: '25mm', weight: '3.858 kg/m', price: 'Price on Request' },
          ],
          specifications: [
            { property: 'Grade', value: 'Fe 500' },
            { property: 'Yield Strength', value: '≥ 500 MPa' },
            { property: 'Ultimate Tensile Strength', value: '≥ 545 MPa' },
            { property: 'Elongation', value: '≥ 14.5%' },
            { property: 'Bend Test', value: 'No cracking' }
          ],
          terms: [
            'Prices are subject to change based on market conditions without prior notice.',
            'GST and other applicable taxes are extra.',
            'Loading charges will be borne by the buyer.',
            'Advance payment is required before dispatch of goods.',
            'All sales are subject to our standard terms and conditions.'
          ]
        },
        {
          slug: 'agroha-tmt',
          name: 'AGROHA TMT',
          image: tmtBarsImg,
          shortDesc: 'Reliable AGROHA TMT bars for construction applications.',
          description: 'AGROHA TMT bars offer superior strength and ductility for demanding construction projects. Ideal for high-rise buildings and major infrastructure.',
          dimensions: [
            { size: '8mm', weight: '0.395 kg/m', price: 'Price on Request' },
            { size: '10mm', weight: '0.617 kg/m', price: 'Price on Request' },
            { size: '12mm', weight: '0.888 kg/m', price: 'Price on Request' },
            { size: '16mm', weight: '1.580 kg/m', price: 'Price on Request' },
            { size: '20mm', weight: '2.469 kg/m', price: 'Price on Request' },
            { size: '25mm', weight: '3.858 kg/m', price: 'Price on Request' },
            { size: '32mm', weight: '6.313 kg/m', price: 'Price on Request' },
          ],
          specifications: [
            { property: 'Grade', value: 'Fe 500' },
            { property: 'Yield Strength', value: '≥ 500 MPa' },
            { property: 'Ultimate Tensile Strength', value: '≥ 545 MPa' },
            { property: 'Elongation', value: '≥ 14.5%' },
            { property: 'Bend Test', value: 'No cracking' }
          ],
          terms: [
            'Prices are subject to change based on market conditions without prior notice.',
            'GST and other applicable taxes are extra.',
            'Loading charges will be borne by the buyer.',
            'Advance payment is required before dispatch of goods.',
            'All sales are subject to our standard terms and conditions.'
          ]
        },
        {
          slug: 'nr-tmt',
          name: 'NR TMT',
          image: tmtBarsImg,
          shortDesc: 'Quality NR TMT bars for reliable construction.',
          description: 'NR TMT bars are manufactured with precision and quality control to ensure excellent performance in all construction applications.',
          dimensions: [
            { size: '8mm', weight: '0.395 kg/m', price: 'Price on Request' },
            { size: '10mm', weight: '0.617 kg/m', price: 'Price on Request' },
            { size: '12mm', weight: '0.888 kg/m', price: 'Price on Request' },
            { size: '16mm', weight: '1.580 kg/m', price: 'Price on Request' },
            { size: '20mm', weight: '2.469 kg/m', price: 'Price on Request' },
            { size: '25mm', weight: '3.858 kg/m', price: 'Price on Request' },
          ],
          specifications: [
            { property: 'Grade', value: 'Fe 500' },
            { property: 'Yield Strength', value: '≥ 500 MPa' },
            { property: 'Ultimate Tensile Strength', value: '≥ 545 MPa' },
            { property: 'Elongation', value: '≥ 14.5%' },
            { property: 'Bend Test', value: 'No cracking' }
          ],
          terms: [
            'Prices are subject to change based on market conditions without prior notice.',
            'GST and other applicable taxes are extra.',
            'Loading charges will be borne by the buyer.',
            'Advance payment is required before dispatch of goods.',
            'All sales are subject to our standard terms and conditions.'
          ]
        },
        {
          slug: 'msp-tmt',
          name: 'MSP TMT',
          image: tmtBarsImg,
          shortDesc: 'High-performance MSP TMT bars for structural applications.',
          description: 'MSP TMT bars are engineered for superior performance in construction projects, offering excellent strength and durability.',
          dimensions: [
            { size: '8mm', weight: '0.395 kg/m', price: 'Price on Request' },
            { size: '10mm', weight: '0.617 kg/m', price: 'Price on Request' },
            { size: '12mm', weight: '0.888 kg/m', price: 'Price on Request' },
            { size: '16mm', weight: '1.580 kg/m', price: 'Price on Request' },
            { size: '20mm', weight: '2.469 kg/m', price: 'Price on Request' },
            { size: '25mm', weight: '3.858 kg/m', price: 'Price on Request' },
          ],
          specifications: [
            { property: 'Grade', value: 'Fe 500' },
            { property: 'Yield Strength', value: '≥ 500 MPa' },
            { property: 'Ultimate Tensile Strength', value: '≥ 545 MPa' },
            { property: 'Elongation', value: '≥ 14.5%' },
            { property: 'Bend Test', value: 'No cracking' }
          ],
          terms: [
            'Prices are subject to change based on market conditions without prior notice.',
            'GST and other applicable taxes are extra.',
            'Loading charges will be borne by the buyer.',
            'Advance payment is required before dispatch of goods.',
            'All sales are subject to our standard terms and conditions.'
          ]
        },
        {
          slug: 'barbrik-tmt',
          name: 'BARBRIK TMT',
          image: tmtBarsImg,
          shortDesc: 'Premium BARBRIK TMT bars for construction excellence.',
          description: 'BARBRIK TMT bars provide excellent strength and durability for various construction applications. Manufactured with advanced technology for consistent quality.',
          dimensions: [
            { size: '8mm', weight: '0.395 kg/m', price: 'Price on Request' },
            { size: '10mm', weight: '0.617 kg/m', price: 'Price on Request' },
            { size: '12mm', weight: '0.888 kg/m', price: 'Price on Request' },
            { size: '16mm', weight: '1.580 kg/m', price: 'Price on Request' },
            { size: '20mm', weight: '2.469 kg/m', price: 'Price on Request' },
            { size: '25mm', weight: '3.858 kg/m', price: 'Price on Request' },
          ],
          specifications: [
            { property: 'Grade', value: 'Fe 500' },
            { property: 'Yield Strength', value: '≥ 500 MPa' },
            { property: 'Ultimate Tensile Strength', value: '≥ 545 MPa' },
            { property: 'Elongation', value: '≥ 14.5%' },
            { property: 'Bend Test', value: 'No cracking' }
          ],
          terms: [
            'Prices are subject to change based on market conditions without prior notice.',
            'GST and other applicable taxes are extra.',
            'Loading charges will be borne by the buyer.',
            'Advance payment is required before dispatch of goods.',
            'All sales are subject to our standard terms and conditions.'
          ]
        },
        {
          slug: 'sky-tmt',
          name: 'SKY TMT',
          image: tmtBarsImg,
          shortDesc: 'High-quality SKY TMT bars for reliable construction.',
          description: 'SKY TMT bars are manufactured with precision and quality control to ensure optimal performance in all construction projects.',
          dimensions: [
            { size: '8mm', weight: '0.395 kg/m', price: 'Price on Request' },
            { size: '10mm', weight: '0.617 kg/m', price: 'Price on Request' },
            { size: '12mm', weight: '0.888 kg/m', price: 'Price on Request' },
            { size: '16mm', weight: '1.580 kg/m', price: 'Price on Request' },
            { size: '20mm', weight: '2.469 kg/m', price: 'Price on Request' },
            { size: '25mm', weight: '3.858 kg/m', price: 'Price on Request' },
          ],
          specifications: [
            { property: 'Grade', value: 'Fe 500' },
            { property: 'Yield Strength', value: '≥ 500 MPa' },
            { property: 'Ultimate Tensile Strength', value: '≥ 545 MPa' },
            { property: 'Elongation', value: '≥ 14.5%' },
            { property: 'Bend Test', value: 'No cracking' }
          ],
          terms: [
            'Prices are subject to change based on market conditions without prior notice.',
            'GST and other applicable taxes are extra.',
            'Loading charges will be borne by the buyer.',
            'Advance payment is required before dispatch of goods.',
            'All sales are subject to our standard terms and conditions.'
          ]
        },
        {
          slug: 'singhal-tmt',
          name: 'SINGHAL TMT',
          image: tmtBarsImg,
          shortDesc: 'Superior SINGHAL TMT bars for structural applications.',
          description: 'SINGHAL TMT bars offer excellent strength and durability for demanding construction applications. Perfect for all construction needs.',
          dimensions: [
            { size: '8mm', weight: '0.395 kg/m', price: 'Price on Request' },
            { size: '10mm', weight: '0.617 kg/m', price: 'Price on Request' },
            { size: '12mm', weight: '0.888 kg/m', price: 'Price on Request' },
            { size: '16mm', weight: '1.580 kg/m', price: 'Price on Request' },
            { size: '20mm', weight: '2.469 kg/m', price: 'Price on Request' },
            { size: '25mm', weight: '3.858 kg/m', price: 'Price on Request' },
          ],
          specifications: [
            { property: 'Grade', value: 'Fe 500' },
            { property: 'Yield Strength', value: '≥ 500 MPa' },
            { property: 'Ultimate Tensile Strength', value: '≥ 545 MPa' },
            { property: 'Elongation', value: '≥ 14.5%' },
            { property: 'Bend Test', value: 'No cracking' }
          ],
          terms: [
            'Prices are subject to change based on market conditions without prior notice.',
            'GST and other applicable taxes are extra.',
            'Loading charges will be borne by the buyer.',
            'Advance payment is required before dispatch of goods.',
            'All sales are subject to our standard terms and conditions.'
          ]
        }
      ]
    },
    {
      slug: 'raipur-tmt-bar',
      name: 'Raipur TMT Bar',
      description: 'Quality TMT bars manufactured in Raipur steel plants, known for consistency and reliability.',
      image: tmtBarsImg,
      products: [
        {
          slug: 'concrete-tmt',
          name: 'CONCRETE TMT',
          image: tmtBarsImg,
          shortDesc: 'High-quality CONCRETE TMT bars with consistent strength and durability.',
          description: 'CONCRETE TMT Bars are manufactured using advanced technology ensuring uniform strength distribution. These bars offer excellent earthquake resistance with optimal strength and ductility.',
          dimensions: [
            { size: '8mm', weight: '0.395 kg/m', price: 'Price on Request' },
            { size: '10mm', weight: '0.617 kg/m', price: 'Price on Request' },
            { size: '12mm', weight: '0.888 kg/m', price: 'Price on Request' },
            { size: '16mm', weight: '1.580 kg/m', price: 'Price on Request' },
            { size: '20mm', weight: '2.469 kg/m', price: 'Price on Request' },
            { size: '25mm', weight: '3.858 kg/m', price: 'Price on Request' },
          ],
          specifications: [
            { property: 'Grade', value: 'Fe 500' },
            { property: 'Yield Strength', value: '≥ 500 MPa' },
            { property: 'Ultimate Tensile Strength', value: '≥ 545 MPa' },
            { property: 'Elongation', value: '≥ 14.5%' },
            { property: 'Bend Test', value: 'No cracking' }
          ],
          terms: [
            'Prices are subject to change based on market conditions without prior notice.',
            'GST and other applicable taxes are extra.',
            'Loading charges will be borne by the buyer.',
            'Advance payment is required before dispatch of goods.',
            'All sales are subject to our standard terms and conditions.'
          ]
        },
        {
          slug: 'udaan-tmt',
          name: 'UDAAN TMT',
          image: tmtBarsImg,
          shortDesc: 'Reliable UDAAN TMT bars for construction applications.',
          description: 'UDAAN TMT bars are engineered for exceptional performance in construction applications. These bars provide excellent strength, ductility, and corrosion resistance.',
          dimensions: [
            { size: '8mm', weight: '0.395 kg/m', price: 'Price on Request' },
            { size: '10mm', weight: '0.617 kg/m', price: 'Price on Request' },
            { size: '12mm', weight: '0.888 kg/m', price: 'Price on Request' },
            { size: '16mm', weight: '1.580 kg/m', price: 'Price on Request' },
            { size: '20mm', weight: '2.469 kg/m', price: 'Price on Request' },
            { size: '25mm', weight: '3.858 kg/m', price: 'Price on Request' },
          ],
          specifications: [
            { property: 'Grade', value: 'Fe 500' },
            { property: 'Yield Strength', value: '≥ 500 MPa' },
            { property: 'Ultimate Tensile Strength', value: '≥ 545 MPa' },
            { property: 'Elongation', value: '≥ 14.5%' },
            { property: 'Bend Test', value: 'No cracking' }
          ],
          terms: [
            'Prices are subject to change based on market conditions without prior notice.',
            'GST and other applicable taxes are extra.',
            'Loading charges will be borne by the buyer.',
            'Advance payment is required before dispatch of goods.',
            'All sales are subject to our standard terms and conditions.'
          ]
        },
        {
          slug: 'nandan-tmt',
          name: 'NANDAN TMT',
          image: tmtBarsImg,
          shortDesc: 'Cost-effective NANDAN TMT bars for general construction needs.',
          description: 'NANDAN TMT bars are manufactured with precision and quality control to ensure optimal performance in all construction projects.',
          dimensions: [
            { size: '8mm', weight: '0.395 kg/m', price: 'Price on Request' },
            { size: '10mm', weight: '0.617 kg/m', price: 'Price on Request' },
            { size: '12mm', weight: '0.888 kg/m', price: 'Price on Request' },
            { size: '16mm', weight: '1.580 kg/m', price: 'Price on Request' },
            { size: '20mm', weight: '2.469 kg/m', price: 'Price on Request' },
            { size: '25mm', weight: '3.858 kg/m', price: 'Price on Request' },
          ],
          specifications: [
            { property: 'Grade', value: 'Fe 500' },
            { property: 'Yield Strength', value: '≥ 500 MPa' },
            { property: 'Ultimate Tensile Strength', value: '≥ 545 MPa' },
            { property: 'Elongation', value: '≥ 14.5%' },
            { property: 'Bend Test', value: 'No cracking' }
          ],
          terms: [
            'Prices are subject to change based on market conditions without prior notice.',
            'GST and other applicable taxes are extra.',
            'Loading charges will be borne by the buyer.',
            'Advance payment is required before dispatch of goods.',
            'All sales are subject to our standard terms and conditions.'
          ]
        },
        {
          slug: 'sarthak-tmt',
          name: 'SARTHAK TMT',
          image: tmtBarsImg,
          shortDesc: 'Heavy-duty SARTHAK TMT bars for major construction projects.',
          description: 'SARTHAK TMT bars provide excellent strength and durability for various construction applications. Manufactured with advanced technology for consistent quality.',
          dimensions: [
            { size: '8mm', weight: '0.395 kg/m', price: 'Price on Request' },
            { size: '10mm', weight: '0.617 kg/m', price: 'Price on Request' },
            { size: '12mm', weight: '0.888 kg/m', price: 'Price on Request' },
            { size: '16mm', weight: '1.580 kg/m', price: 'Price on Request' },
            { size: '20mm', weight: '2.469 kg/m', price: 'Price on Request' },
            { size: '25mm', weight: '3.858 kg/m', price: 'Price on Request' },
          ],
          specifications: [
            { property: 'Grade', value: 'Fe 500' },
            { property: 'Yield Strength', value: '≥ 500 MPa' },
            { property: 'Ultimate Tensile Strength', value: '≥ 545 MPa' },
            { property: 'Elongation', value: '≥ 14.5%' },
            { property: 'Bend Test', value: 'No cracking' }
          ],
          terms: [
            'Prices are subject to change based on market conditions without prior notice.',
            'GST and other applicable taxes are extra.',
            'Loading charges will be borne by the buyer.',
            'Advance payment is required before dispatch of goods.',
            'All sales are subject to our standard terms and conditions.'
          ]
        },
        {
          slug: 'gk-tmt',
          name: 'GK TMT',
          image: tmtBarsImg,
          shortDesc: 'Premium GK TMT bars for superior construction quality.',
          description: 'GK TMT bars are engineered for exceptional performance in construction applications, providing excellent strength and durability.',
          dimensions: [
            { size: '8mm', weight: '0.395 kg/m', price: 'Price on Request' },
            { size: '10mm', weight: '0.617 kg/m', price: 'Price on Request' },
            { size: '12mm', weight: '0.888 kg/m', price: 'Price on Request' },
            { size: '16mm', weight: '1.580 kg/m', price: 'Price on Request' },
            { size: '20mm', weight: '2.469 kg/m', price: 'Price on Request' },
            { size: '25mm', weight: '3.858 kg/m', price: 'Price on Request' },
          ],
          specifications: [
            { property: 'Grade', value: 'Fe 500' },
            { property: 'Yield Strength', value: '≥ 500 MPa' },
            { property: 'Ultimate Tensile Strength', value: '≥ 545 MPa' },
            { property: 'Elongation', value: '≥ 14.5%' },
            { property: 'Bend Test', value: 'No cracking' }
          ],
          terms: [
            'Prices are subject to change based on market conditions without prior notice.',
            'GST and other applicable taxes are extra.',
            'Loading charges will be borne by the buyer.',
            'Advance payment is required before dispatch of goods.',
            'All sales are subject to our standard terms and conditions.'
          ]
        },
        {
          slug: 'utkal-tmt',
          name: 'UTKAL TMT',
          image: tmtBarsImg,
          shortDesc: 'High-grade UTKAL TMT bars for reliable structural applications.',
          description: 'UTKAL TMT bars are manufactured with precision and quality control to ensure excellent performance in all construction applications.',
          dimensions: [
            { size: '8mm', weight: '0.395 kg/m', price: 'Price on Request' },
            { size: '10mm', weight: '0.617 kg/m', price: 'Price on Request' },
            { size: '12mm', weight: '0.888 kg/m', price: 'Price on Request' },
            { size: '16mm', weight: '1.580 kg/m', price: 'Price on Request' },
            { size: '20mm', weight: '2.469 kg/m', price: 'Price on Request' },
            { size: '25mm', weight: '3.858 kg/m', price: 'Price on Request' },
          ],
          specifications: [
            { property: 'Grade', value: 'Fe 500' },
            { property: 'Yield Strength', value: '≥ 500 MPa' },
            { property: 'Ultimate Tensile Strength', value: '≥ 545 MPa' },
            { property: 'Elongation', value: '≥ 14.5%' },
            { property: 'Bend Test', value: 'No cracking' }
          ],
          terms: [
            'Prices are subject to change based on market conditions without prior notice.',
            'GST and other applicable taxes are extra.',
            'Loading charges will be borne by the buyer.',
            'Advance payment is required before dispatch of goods.',
            'All sales are subject to our standard terms and conditions.'
          ]
        },
        {
          slug: 'nirman-tmt',
          name: 'NIRMAN TMT',
          image: tmtBarsImg,
          shortDesc: 'Quality NIRMAN TMT bars for dependable construction solutions.',
          description: 'NIRMAN TMT bars are manufactured with strict quality standards to ensure consistent performance in various construction applications.',
          dimensions: [
            { size: '8mm', weight: '0.395 kg/m', price: 'Price on Request' },
            { size: '10mm', weight: '0.617 kg/m', price: 'Price on Request' },
            { size: '12mm', weight: '0.888 kg/m', price: 'Price on Request' },
            { size: '16mm', weight: '1.580 kg/m', price: 'Price on Request' },
            { size: '20mm', weight: '2.469 kg/m', price: 'Price on Request' },
            { size: '25mm', weight: '3.858 kg/m', price: 'Price on Request' },
          ],
          specifications: [
            { property: 'Grade', value: 'Fe 500' },
            { property: 'Yield Strength', value: '≥ 500 MPa' },
            { property: 'Ultimate Tensile Strength', value: '≥ 545 MPa' },
            { property: 'Elongation', value: '≥ 14.5%' },
            { property: 'Bend Test', value: 'No cracking' }
          ],
          terms: [
            'Prices are subject to change based on market conditions without prior notice.',
            'GST and other applicable taxes are extra.',
            'Loading charges will be borne by the buyer.',
            'Advance payment is required before dispatch of goods.',
            'All sales are subject to our standard terms and conditions.'
          ]
        }
      ]
    }
  ]
};
